var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { CommunicationChartNodeKindEnum } from '@web/components/CommunicationNetworkGraph/core/communicationChart/nodeKind';
import { COMMUNICATION_CHART_COLORS, COMMUNICATION_CHART_OPACITY } from '@web/components/CommunicationNetworkGraph/graph/communicationChartConstants';
import { COMMUNICATION_CHART_CYTOSCAPE_TRANSITION } from '@web/components/CommunicationNetworkGraph/graph/communicationChartMotion';
var avatarNodeBaseStyle = {
    'background-opacity': 0,
    'border-width': 0,
    shape: 'ellipse'
};
/** Circle paint (fill, strokes) is drawn on the canvas overlay. */
var canvasDrawnNodeStyle = {
    'background-opacity': 0,
    'border-width': 0
};
/** Invisible cytoscape hit target larger than the painted circle (canvas overlay). */
var canvasDrawnNodeHitTargetStyle = {
    'overlay-opacity': 0,
    'overlay-padding': 10
};
var canvasDrawnSyntheticNodeKinds = [
    CommunicationChartNodeKindEnum.External,
    CommunicationChartNodeKindEnum.CrossTeamAggregate,
    CommunicationChartNodeKindEnum.InternalMeet,
    CommunicationChartNodeKindEnum.CrossTeamSpaceChat,
    CommunicationChartNodeKindEnum.ExternalSpaceChat,
    CommunicationChartNodeKindEnum.Other,
    CommunicationChartNodeKindEnum.CrossTeam
];
var canvasDrawnSyntheticNodeSelector = canvasDrawnSyntheticNodeKinds
    .map(function (kind) { return "node.".concat(kind); })
    .join(', ');
var canvasDrawnSyntheticHighlightedSelector = canvasDrawnSyntheticNodeKinds
    .map(function (kind) { return "node.".concat(kind, ".highlighted"); })
    .join(', ');
var personLabelHiddenStyle = {
    label: 'data(label)',
    'text-valign': 'bottom',
    'text-halign': 'center',
    'text-margin-y': 10,
    'font-size': 12,
    'font-weight': 600,
    'font-family': 'Inter, ui-sans-serif, system-ui, -apple-system, sans-serif',
    color: COMMUNICATION_CHART_COLORS.label,
    'text-opacity': 0
};
export var COMMUNICATION_CHART_CYTOSCAPE_STYLES = [
    {
        selector: 'core',
        style: {
            'background-color': 'transparent'
        }
    },
    {
        selector: 'node',
        style: __assign(__assign(__assign({ label: 'data(label)', 'text-valign': 'bottom', 'text-halign': 'center', 'text-margin-y': 8, 'font-size': 12, 'font-family': 'Inter, ui-sans-serif, system-ui, -apple-system, sans-serif', color: COMMUNICATION_CHART_COLORS.label }, canvasDrawnNodeStyle), { width: 'data(nodeSize)', height: 'data(nodeSize)', 'z-index': 2 }), COMMUNICATION_CHART_CYTOSCAPE_TRANSITION)
    },
    {
        selector: 'node.personNode',
        style: __assign(__assign({}, personLabelHiddenStyle), avatarNodeBaseStyle)
    },
    {
        selector: 'node.personNode.highlighted',
        style: {
            'text-opacity': 1
        }
    },
    {
        selector: 'node.teamScopePerson, node.teamScopePerson.highlighted, node.teamScopeManagerPerson, node.teamScopeManagerPerson.highlighted, node.employeeFocusPerson, node.employeeFocusPerson.highlighted',
        style: {
            'text-opacity': 0
        }
    },
    {
        selector: canvasDrawnSyntheticNodeSelector,
        style: __assign(__assign(__assign({}, canvasDrawnNodeStyle), canvasDrawnNodeHitTargetStyle), { width: 'data(nodeSize)', height: 'data(nodeSize)', 'text-opacity': 0, 'z-index': 3 })
    },
    {
        selector: 'node.teamHubSatellite',
        style: __assign(__assign({}, canvasDrawnNodeHitTargetStyle), { 'overlay-padding': 14 })
    },
    {
        selector: 'node.external.hovered',
        style: {
            'text-opacity': 0
        }
    },
    {
        selector: 'node.orgTeam',
        style: {
            'text-opacity': 0
        }
    },
    {
        selector: 'node.highlighted',
        style: __assign(__assign({}, canvasDrawnNodeStyle), { color: COMMUNICATION_CHART_COLORS.label })
    },
    {
        selector: canvasDrawnSyntheticHighlightedSelector,
        style: canvasDrawnNodeStyle
    },
    {
        selector: 'node.selectedNode',
        style: canvasDrawnNodeStyle
    },
    {
        selector: 'node.dimmed',
        style: {
            color: '#94A3B8',
            opacity: COMMUNICATION_CHART_OPACITY.nodeDimmed
        }
    },
    {
        selector: 'edge',
        style: __assign({ width: 'data(width)', 'line-color': 'data(lineColor)', 'curve-style': 'unbundled-bezier', 'control-point-step-size': 40, 'control-point-distances': 'data(controlPointDistance)', 'control-point-weights': 0.5, opacity: COMMUNICATION_CHART_OPACITY.edge, 'z-index': 1, 'line-cap': 'round', 'source-distance-from-node': 'data(sourceArrowGapPx)', 'target-distance-from-node': 'data(targetArrowGapPx)', 'source-arrow-shape': 'none', 'target-arrow-shape': 'none' }, COMMUNICATION_CHART_CYTOSCAPE_TRANSITION)
    },
    {
        selector: 'edge.has-source-arrow, edge.has-target-arrow',
        style: {
            'line-cap': 'butt'
        }
    },
    {
        selector: 'edge.trend-new',
        style: {
            'line-style': 'dashed',
            'line-dash-pattern': [8, 6],
            'line-cap': 'butt'
        }
    },
    {
        selector: 'edge.channel-chat, edge.channel-email',
        style: {
            'z-index': 2
        }
    },
    {
        selector: 'edge.channel-meet',
        style: {
            'z-index': 2,
            'line-cap': 'round'
        }
    },
    {
        selector: 'edge.channel-meet.trend-new',
        style: {
            'line-style': 'dashed',
            'line-dash-pattern': [8, 6],
            'line-cap': 'butt'
        }
    },
    {
        selector: 'edge.channel-meet.dimmed',
        style: {
            'line-color': COMMUNICATION_CHART_COLORS.linkTrendDimmed,
            opacity: COMMUNICATION_CHART_OPACITY.edgeMeetDimmed
        }
    },
    {
        selector: 'edge.highlighted',
        style: {
            opacity: 1
        }
    },
    {
        selector: 'edge.dimmed',
        style: {
            'line-color': COMMUNICATION_CHART_COLORS.linkDimmed,
            opacity: COMMUNICATION_CHART_OPACITY.edgeDimmed
        }
    },
    {
        selector: 'node.personNode.dimmed',
        style: __assign(__assign({}, avatarNodeBaseStyle), { color: '#94A3B8', opacity: COMMUNICATION_CHART_OPACITY.nodeDimmed })
    },
    {
        selector: 'node.orgTeam.dimmed',
        style: {
            opacity: 1
        }
    },
    {
        selector: 'node.teamHubSatellite.hubHidden',
        style: {
            opacity: 0,
            'text-opacity': 0,
            'background-opacity': 0,
            'border-opacity': 0,
            display: 'none',
            events: 'no'
        }
    },
    {
        selector: 'edge.teamHubEdge.hubHidden',
        style: {
            opacity: 0,
            'line-opacity': 0,
            width: 0,
            display: 'none',
            events: 'no'
        }
    }
];
